import { useState } from 'react';
import { Badge, Button, Card, cx } from '../Ui';
import {
  deliveryTypeLabels,
  fulfillmentLabels,
  orderStatusLabels,
  orderStatusTone,
} from './control-tower-utils';
import type { OrderView } from './control-tower-utils';

interface ControlTowerExceptionsProps {
  orders: OrderView[];
}

/** Supervision-only listing of cancelled / ghost / cancelled-fulfillment orders. */
export function ControlTowerExceptions({ orders }: ControlTowerExceptionsProps) {
  const [open, setOpen] = useState(false);

  if (orders.length === 0) return null;

  return (
    <Card className="p-0">
      <div className="flex items-center justify-between gap-3 p-4">
        <div className="flex items-center gap-3">
          <span className="font-black text-foreground">Excepciones</span>
          <Badge tone="purple">{orders.length}</Badge>
        </div>
        <Button type="button" variant="secondary" onClick={() => setOpen((value) => !value)}>
          {open ? 'Ocultar' : 'Ver'}
        </Button>
      </div>

      {open && (
        <ul className="grid gap-2 border-t border-separator p-4">
          {orders.map((order) => (
            <li
              key={order.id}
              className="grid gap-1.5 rounded-xl border border-rose-200 bg-rose-50/40 px-3 py-2.5 text-sm"
            >
              <div className="flex flex-wrap items-center gap-2">
                <span className="font-black text-foreground">
                  #{String(order.correlation).padStart(2, '0')}
                </span>
                <span className="text-muted">{order.customerName || 'Cliente'}</span>
                <span className="text-xs text-muted">{deliveryTypeLabels[order.deliveryType]}</span>
              </div>
              <div className="flex flex-wrap items-center gap-1.5">
                <Badge tone={orderStatusTone[order.status]}>{orderStatusLabels[order.status]}</Badge>
                {order.fulfillmentStage === 'cancelled' && (
                  <Badge tone="red">{fulfillmentLabels.cancelled}</Badge>
                )}
              </div>
              {order.notes && <p className={cx('text-xs text-muted')}>{order.notes}</p>}
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
